import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-success-screen-wait-list',
  templateUrl: './success-screen-wait-list.component.html',
  styleUrls: ['./success-screen-wait-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SuccessScreenWaitListComponent implements OnInit {

  @Input() public display = false;
  @Input() public loading = false;
  constructor() { }

  ngOnInit() {
  }

}
